import { TextInput } from '@insight-health-ai/roseate/components';
import type { InputProps } from './types';

const TYPE_MAP: Record<string, string> = {
  email: 'email',
  phone: 'tel',
};

export function Text({ field, value, onChange, autoFocus }: InputProps) {
  return (
    <TextInput
      type={TYPE_MAP[field.type] ?? 'text'}
      value={(value as string) || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={field.placeholder}
      required={field.required}
      disabled={field.disabled}
      autoFocus={autoFocus}
      className={field.inputClassName}
    />
  );
}
